<script>
  import { onMount } from "svelte";
let ref;
let showMore = false;


</script>
<div style="{!showMore ? 'max-height:150px;overflow:hidden' : ''}" bind:this={ref}>
    <slot />
</div>
{#if ref && ref.scrollHeight > 150 && !showMore}
    <hr style="margin:0"/>
    <a href="#" on:click|preventDefault={()=> showMore = true} style="font-size:0.8rem;display:block">Show more</a>
{:else if showMore}
 <a href="#" on:click|preventDefault={()=> showMore = false} style="font-size:0.8rem;display:block">Show less</a>
{/if}